import { render, staticRenderFns } from "./MoneyBorrow.vue?vue&type=template&id=4a7ce911&scoped=true"
import script from "./MoneyBorrow.vue?vue&type=script&lang=js"
export * from "./MoneyBorrow.vue?vue&type=script&lang=js"
import style0 from "./MoneyBorrow.vue?vue&type=style&index=0&id=4a7ce911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7ce911",
  null
  
)

export default component.exports